export enum CruiseDetailTabs {
  ITINERARY,
  SHIP_INFO,
  EXCURSIONS
}
